/**
 * Sezione «Modulo ENISA» del dettaglio report: stato della bozza (dal payload del report, nessuna
 * fetch in più) e bottone che apre il pop-up con tutti i campi del sito ENISA.
 */
import { useState } from 'react';
import { usePermissions } from '../../../auth/usePermissions.js';
import type { SrpReport } from '../types.js';
import type { EnisaFormDraft } from './types.js';
import { EnisaFormDialog } from './EnisaFormDialog.js';
import styles from './EnisaForm.module.css';

export function EnisaFormSection({ report }: { report: SrpReport }) {
  const { can } = usePermissions();
  const [aperto, setAperto] = useState(false);
  const bozza = report.payload['enisaForm'] as EnisaFormDraft | undefined;

  return (
    <div className={styles.section} data-testid="enisa-form-sezione">
      <div>
        <p className={styles.sectionTitle}>Modulo ENISA</p>
        <p className={styles.muted} data-testid="enisa-form-riepilogo">
          {bozza
            ? `Bozza rev. ${bozza.revision} — salvata il ${new Date(bozza.updatedAt).toLocaleString(
                'it-IT',
              )} da ${bozza.updatedBy}.`
            : 'Nessuna bozza: i campi del sito ENISA si compilano qui una volta sola (precompilati dal report) e si esportano in JSON per l’estensione Chrome.'}
        </p>
      </div>
      <button
        type="button"
        className={styles.btnPrimary}
        onClick={() => setAperto(true)}
        data-testid="enisa-form-apri"
      >
        {bozza ? 'Apri modulo ENISA' : 'Compila modulo ENISA'}
      </button>
      {aperto && (
        <EnisaFormDialog
          reportId={report.id}
          canEdit={can('VULNERABILITY_ANALYSIS')}
          onClose={() => setAperto(false)}
        />
      )}
    </div>
  );
}
